import { Link } from "@remix-run/react";
import {
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Listbox,
  ListboxItem,
  useDisclosure,
} from "@heroui/react";
import { FiLogIn } from "react-icons/fi";
import { TbTruckDelivery } from "react-icons/tb";
import { SearchDropdown } from "./SearchDropdown";
import { MdAccountCircle } from "react-icons/md";
import DarkModeSwitch from "../DarkModeSwitch";
import { userAtom } from "app/atoms/user.atom";
import { useAtomValue } from "jotai";

type SecondaryNavProps = {
  uid: string | null;
};

export function SecondaryNav({ uid }: SecondaryNavProps) {
    const user = useAtomValue(userAtom);
    const {
      isOpen: isAccountOpen,
      onOpen: onAccountOpen,
      onOpenChange: onAccountOpenChange,
    } = useDisclosure();
  return (
    <nav
      aria-label="Secondary navigation"
      className="w-full border-t border-gray-200 dark:border-gray-600  py-2"
    >
      <div className="flex flex-col sm:flex-row sm:items-center gap-3 w-full min-w-0">
        <div className="flex-1 min-w-0">
          <SearchDropdown />
        </div>
        <div className="hidden xl:flex items-center gap-2 flex-wrap shrink-0">
          <div
            role="note"
            aria-label="Fast Delivery Australia Wide"
            className="border border-gray-200 dark:border-gray-600 rounded-lg text-sm font-medium px-3 py-2 flex items-center gap-2 bg-white dark:bg-gray-800/50 shrink-0"
          >
            <TbTruckDelivery
              className="text-2xl text-orange-700 dark:text-orange-300 shrink-0"
              aria-hidden
            />
            <span>Fast Delivery Australia Wide</span>
          </div>
          {!uid ? (
            <Button
              as={Link}
              to="/login"
              size="md"
              variant="bordered"
              aria-label="Login"
              startContent={<FiLogIn className="text-lg text-primary" aria-hidden />}
              className="border-gray-200 dark:border-gray-600 font-medium text-sm rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
            >
              Login
            </Button>
          ) : (
            <Popover
              isOpen={isAccountOpen}
              onOpenChange={onAccountOpenChange}
              showArrow
              placement="bottom-end"
            >
              <PopoverTrigger>
                <Button
                  type="button"
                  variant="bordered"
                  size="md"
                  aria-label="Account"
                  startContent={<MdAccountCircle className="text-lg text-primary" aria-hidden />}
                  className="border-gray-200 dark:border-gray-600 font-medium text-sm rounded-lg"
                  onPress={() => onAccountOpen()}
                >
                  Account
                </Button>
              </PopoverTrigger>
              <PopoverContent className="max-w-md p-3">
                <div className="flex flex-col gap-2">
                  <div className="mb-2">
                    <span className=" text-lg font-semibold"> {user?.firstName || "Account"}</span>
                  </div>
                  <Listbox aria-label="Actions">
                    <ListboxItem as={Link} to="edit-account" key="edit-account">
                      Edit Account
                    </ListboxItem>
                    <ListboxItem as={Link} to="account" key="all-orders">
                      All Orders
                    </ListboxItem>
                    {/* <ListboxItem key="log-out" className="text-danger" color="danger">
                                Log Out
                              </ListboxItem> */}
                  </Listbox>
                </div>
              </PopoverContent>
            </Popover>
          )}
          <div className="flex">
            <DarkModeSwitch />
          </div>
        </div>
      </div>
    </nav>
  );
}
